import { timer } from "rxjs";

export const moveItem = (array: any, from: number, to: number) => {
  const item = array.splice(from, 1)[0];
  array.splice(to, 0, item);
  return array;
}

export const hasUppercase = (str: string) => {
  return /[A-Z]/.test(str);
}

export const hasSpecialCharacter = (str: string) => {
  return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(str);
}

export const hasLowerCase = (str: string) => {
  return /[a-z]/.test(str);
}

export const hasNumber = (str: string) => {
  return /\d/.test(str);
}

export const sortByColumnName = (array: any, name: string, sortBy: 'asc' | 'desc' = 'asc') => {
  return array.sort((a: any, b: any) => {
    const valA = a[name];
    const valB = b[name];

    if (valA < valB) return sortBy === 'asc' ? -1 : 1;
    if (valA > valB) return sortBy === 'asc' ? 1 : -1;
    return 0;
  });
}

export const numberWithCommas = (x: number | string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// checkFormGroupValues<T>(value: any): asserts value is NonNullable<T> {
// if (value === undefined || value === null) {
//   throw new Error(`${value} is not defined`)
// }
//   for (const key in Object.keys(obj)) {
//     if (obj.hasOwnProperty(key)) {
//       if (typeof obj[key] != boolean)
//       if (obj[key] && obj[key] === null && obj[key] === undefined) {
//         return false;
//       }
//     }
//   }
// }

function assertIsDefined<T>(value: T): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new Error(`${value} is not defined`)
  }
}

export const delayDataFetching = (value: number) => {
  return timer(value);
}

export function convertFileToBase64(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;
      // Remove the "data:<mime>;base64," prefix
      const base64String = result.split(',')[1];
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    }

    reader.readAsDataURL(file);
  })
}

export function generateDays(daysInMonth: number): number[] {
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
}

export function generateMonths(): { name: string, value: number }[] {
  return [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 }
  ];
}

export function generateYears(): number[] {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 100 }, (_, i) => currentYear - i);
}

export function generateGraduationYear(startYear?: number): { label: string, value: string }[] {
  const currentYear = new Date().getFullYear();
  const baseYear = startYear ?? currentYear;
  const endYear = currentYear + 7; // 8 years inclusive
  const numberOfYears = endYear - baseYear + 1;
  return Array.from({ length: numberOfYears }, (_, i) => baseYear + i).map(
    e => ({ label: e.toString(), value: e.toString() })
  );
}

export function stringToBoolean(str: any): boolean {
  if (!str) return false;
  if (str == "null" || str == "undefined") return false;
  return str === 'true';
}
